import { z } from 'zod';

/**
 * Die Kontakt-E-Mail eines Workspace ist die Antwortadresse jeder seiner Mails. Spiegelt
 * `WorkspaceValidationRules.ValidReplyAddress`: genau ein Postfach mit Domain, ohne Anzeigenamen —
 * was der Versand nicht unverändert übernimmt, ließe er still weg. Zods E-Mail-Regel ist dabei die
 * strengere (keine Punkte am Rand oder doppelt, keine Zeichen wie `;`), damit nichts erst am
 * Server scheitert.
 */
export const replyAddressSchema = z.union([
  z.literal(''),
  z.string().trim().email('Ungültige E-Mail-Adresse').max(320, 'Max. 320 Zeichen'),
]);

/** Steht an beiden Feldern: Wer die Adresse einträgt, soll wissen, wer sie sieht. */
export const REPLY_ADDRESS_HINT =
  'Antwortadresse aller Mails dieses Workspace – jeder Empfänger, auch Gäste, sieht sie.';
